$(document).ready(function(){

  // initialize slideshow of facility photos
  facilityPhotos();

  /*** google maps ***/
  if ($('#map').length) {
    var latitude = $('#map').attr('data-latitude');
    var longitude = $('#map').attr('data-longitude');
    var mapId = 'map';

    var myLatLng = new google.maps.LatLng(latitude, longitude);

    var mapOptions = {
      zoom: 16,
      center: myLatLng,
      draggable: true,
      disableDefaultUI: false,
      clickableIcons: false
    };
    var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

    var marker = new google.maps.Marker({
      position: myLatLng,
      map: map
    });

  }

});
